import React, { FunctionComponent } from 'react';
import { Card, Form, Tooltip } from 'antd';

import { IAppComponentProps } from '../../components';
import SurveyVerifySubmit from './SurveyVerifySubmit/SurveyVerifySubmit-component';
import { SELECTED_GROUP_ID } from '../../constants';
import { useIntl } from 'react-intl';
import { StateContainer } from './utilities/StateContainer';
import { Link } from 'react-router-dom';
import { getI18n } from '../../utils/Utils';
import { HomeOutlined } from '@ant-design/icons';
import styling from './styling/survey.module.css';

type ISurveyVerifySubmitStepProps = {
    next?: any;
    prev?: any;
    onStatusUpdate: any;
    stateContainer?: StateContainer;
} & IAppComponentProps;

const SurveyVerifySubmitStep: FunctionComponent<ISurveyVerifySubmitStepProps> = (props) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const groupID = localStorage.getItem(SELECTED_GROUP_ID);
  return (
    <>
      <Card title={
        <>
         <span style={{ marginRight: '20px'}}>
                        <Link to={'/survey/survey-overview'}>
                            <Tooltip
                                title={getI18n(
                                    'survey-master-data-partner-tab-back-icon-tool-tip',
                                    'Return to Survey Overview Page',
                                    intl
                                )}
                                key={'keyCancelInvoiceIcon'}
                            >
                                <HomeOutlined
                                    style={{
                                      fontSize: '25px',
                                      cursor: 'pointer',
                                      color: '#024051',
                                      marginBottom: '15px',
                                    }}
                                />
                            </Tooltip>
                        </Link>
                    </span>
        <span>{intl.formatMessage({
        id: "verifySubmit-tab-title",
        defaultMessage: "Verify & Submit"
        })}
        </span>
      </>}
      className={`${styling.removeUnderLine}`}
      size={"small"} bordered={true}>
        <SurveyVerifySubmit  form={form} groupId={groupID} onStatusUpdate={props.onStatusUpdate}/>
      </Card>
    </>
  );

};

export default SurveyVerifySubmitStep;
